import { type DisplayTextItem } from '../types';
export const DisplayTextViewItem = ({
  item
}: {
  item: DisplayTextItem | undefined;
}) => {
  if (!item || !item.label) return null;
  return <span className={item.isHoverPreview ? 'text-[#9e9faf]' : 'text-black'} data-sentry-component="DisplayTextViewItem" data-sentry-source-file="DisplayTextItem.tsx">
      {item.label}
    </span>;
};
export const Space = () => {
  const space = ' ';
  return <span data-sentry-component="Space" data-sentry-source-file="DisplayTextItem.tsx">{space}</span>;
};